import type { ReturnRequestDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";
import { useInvalidateReturnRequest } from "./use-invalidate-return-request";

interface UseGenerateLabelParams {
	onSuccess?: (returnRequest: ReturnRequestDto) => void;
	onError?: (error: Error) => void;
	notify?: boolean | { success?: boolean; error?: boolean };
}

export default function useGenerateLabel(params: UseGenerateLabelParams) {
	const invalidateReturnRequest = useInvalidateReturnRequest();

	return useApiMutation(
		"post",
		"/shops/{shopId}/return-requests/{returnRequestId}/generate-label",
		{
			notify: params.notify,
			onSuccess: (returnRequest: ReturnRequestDto) => {
				invalidateReturnRequest({
					returnRequestId: returnRequest.id,
					shopId: returnRequest.shopId,
				});
				params.onSuccess?.(returnRequest);
			},
			// A refused label is still written to the activity log before the
			// 422 comes back: refetch, or the entry the caller scrolls to is
			// missing.
			onError: (error, variables) => {
				invalidateReturnRequest(variables);
				params.onError?.(error as Error);
			},
			mapVariables: (body: { shopId: string; returnRequestId: string }) => ({
				params: {
					path: { shopId: body.shopId, returnRequestId: body.returnRequestId },
				},
			}),
		},
	);
}
